import { InfiniteScroll} from 'antd-mobile'
import { InfiniteScrollProps} from 'antd-mobile/cjs/components/infinite-scroll'

export default InfiniteScroll

export {
  InfiniteScrollProps,
}